import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../theme";
export const Navigation = ({ children, }) => (_jsx(Wrapper, { children: _jsx(ContentContainer, { children: children }) }));
const Wrapper = styled.div `
  position: fixed;
  z-index: 998;
  top: 0;
  width: 100%;
  height: 70px;
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
`;
const ContentContainer = styled.div `
  display: flex;
  max-width: Min(1920px, 100vw - 4rem);
  align-items: center;
  justify-content: space-between;
  height: 70px;
  margin: 0 auto;
`;
